import React, { useState } from 'react';
import { Grid, Chip, Typography, Box, Snackbar, Alert, Tooltip } from '@mui/material';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from '../axios';

const MySwal = withReactContent(Swal);

const Roadmap = ({ idCorso, idAlunno, dataInizioCorso, nomeAlunno, cognomeAlunno, roadmap, updateAllRoadmaps, updateRoadmap }) => {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const showSnackbar = (message, severity = 'success') => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setOpenSnackbar(true);
    };

    const isCourseStarted = () => {
        const currentDate = new Date();
        const startDate = new Date(
            parseInt(dataInizioCorso.substring(0, 4)),
            parseInt(dataInizioCorso.substring(4, 6)) - 1,
            parseInt(dataInizioCorso.substring(6, 8))
        );
        return currentDate >= startDate;
    };

    const getChipProps = (item) => {
        const currentDate = new Date();
        const phaseDate = new Date(
            parseInt(item.datafase.substring(0, 4)),
            parseInt(item.datafase.substring(5, 7)) - 1,
            parseInt(item.datafase.substring(8, 10))
        );

        if (item.sent === '1') {
            return { backgroundColor: '#90ee90', color: 'black', clickable: false, tooltip: 'Messaggio inviato' };
        } else if (!isCourseStarted()) {
            return { backgroundColor: '#d3d3d3', color: 'black', clickable: false, tooltip: 'Corso non iniziato, impossibile inviare il messaggio' };
        } else if (item.sent === '0' && phaseDate < currentDate) {
            return { backgroundColor: '#ff6961', color: 'black', clickable: true, tooltip: 'Messaggio da inviare, data trascorsa' };
        } else {
            return { backgroundColor: '#fdfd96', color: 'black', clickable: true, tooltip: 'Messaggio non inviato' };
        }
    };

    const getAnteprimaMessaggio = async (idTemplate) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post("/datahandler/anteprima-messaggio", {
                token,
                idTemplate
            });


            if (response.data.success && response.data.testo) {
                return response.data.testo;
            } else {
                console.warn("Anteprima non disponibile:", response.data.error || "Errore sconosciuto");
                return "Anteprima non disponibile.";
            }
        } catch (error) {
            console.error("Errore durante il recupero dell'anteprima:", error);
            return "Errore durante il recupero dell'anteprima.";
        }
    };



    const handleChipClick = async (item) => {
        const anteprima = await getAnteprimaMessaggio(item.id); // Assicurati che questa funzione esista e ritorni il testo


        const result = await MySwal.fire({
            title: `Invia ${item.codice}`,
            html: `
            <div style="text-align: left;">
                <strong>Anteprima messaggio:</strong><br>
                <div style="
                    margin-top: 10px;
                    white-space: pre-wrap;
                    max-height: 300px;
                    overflow-y: auto;
                    padding: 10px;
                    border: 1px solid #ccc;
                    background-color: #f9f9f9;
                ">
                    ${anteprima}
                </div>
            </div>
        `,
            showCancelButton: true,
            confirmButtonText: `Invia ${item.codice} a tutti i DinoAlunni del corso`,
            cancelButtonText: `Invia ${item.codice} a ${nomeAlunno} ${cognomeAlunno}`,
            showCloseButton: true
        });

        if (result.isConfirmed) {
            await sendViaggio({ idAlunno: 0, idCorso, idTemplate: item.id }, item.codice, true);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            await sendViaggio({ idAlunno, idCorso, idTemplate: item.id }, item.codice, false);
        }
    };











    const sendViaggio = async (data, codice, updateCourse) => {
        const token = localStorage.getItem('token');
        try {
            await axios.post('datahandler/send-viaggio', { ...data, token });
            showSnackbar(`${codice} inviato con successo`, 'success');
            if (updateCourse) {
                updateAllRoadmaps();  // Ricarica tutte le roadmap dopo l'invio
            } else {
                // Ricarica la roadmap per il singolo alunno
                updateRoadmap(data.idAlunno);
            }
        } catch (error) {
            console.error('Error sending viaggio:', error);
            showSnackbar('Errore durante l\'invio del viaggio', 'error');
            Swal.fire('Errore', 'Errore durante l\'invio del viaggio', 'error');
        }
    };

    return (
        <Box mt={2} mb={1}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#555', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 4, height: 16, bgcolor: '#0288d1', borderRadius: 4 }} />
                Roadmap Viaggi
            </Typography>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.8,
                p: 1.2,
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                backdropFilter: 'blur(8px)',
                boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.4)'
            }}>
                {roadmap.length > 0 ? (
                    roadmap.map(item => {
                        const { backgroundColor, color, clickable, tooltip } = getChipProps(item);

                        // Refine colors for more modern pastel look
                        let refinedBg = backgroundColor;
                        let refinedText = color;

                        if (backgroundColor === '#90ee90') { // Sent
                            refinedBg = '#c8e6c9';
                            refinedText = '#1b5e20';
                        } else if (backgroundColor === '#ff6961') { // Overdue
                            refinedBg = '#ffcdd2';
                            refinedText = '#b71c1c';
                        } else if (backgroundColor === '#fdfd96') { // Pending
                            refinedBg = '#fff9c4';
                            refinedText = '#f57f17';
                        } else if (backgroundColor === '#d3d3d3') { // Disabled
                            refinedBg = '#eeeeee';
                            refinedText = '#9e9e9e';
                        }

                        return (
                            <Grid item key={item.id}>
                                <Tooltip title={tooltip} arrow placement="top">
                                    <Chip
                                        label={item.codice}
                                        size="small"
                                        onClick={() => clickable && handleChipClick(item)}
                                        sx={{
                                            height: 24,
                                            fontSize: '0.7rem',
                                            fontWeight: 700,
                                            bgcolor: refinedBg,
                                            color: refinedText,
                                            cursor: clickable ? 'pointer' : 'default',
                                            border: '1px solid rgba(0,0,0,0.05)',
                                            borderRadius: '6px',
                                            transition: 'all 0.2s ease',
                                            '& .MuiChip-label': { px: 1 },
                                            '&:hover': {
                                                transform: clickable ? 'translateY(-2px)' : 'none',
                                                boxShadow: clickable ? '0 4px 8px rgba(0,0,0,0.1)' : 'none',
                                                bgcolor: refinedBg,
                                                filter: clickable ? 'brightness(0.95)' : 'none'
                                            },
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                        );
                    })
                ) : (
                    <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic', pl: 1 }}>
                        Nessuna roadmap caricata.
                    </Typography>
                )}
            </Box>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%', borderRadius: '12px', fontWeight: 600 }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Roadmap;
